import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid } from '@material-ui/core';

import { Card } from 'core/components/card';
import { FormField } from 'core/components/form';
import notificationIconWhite from 'core/assets/svg/ic-info-white.svg';
import useStyles from './mega-down-pay-card.styles';

const MegaDownPayCard = ({ megaDownPayRequired, formikValue }) => {
  const classes = useStyles();
  return (
    <Card className={classes.warning}>
      <img src={notificationIconWhite} alt="Notification Icon" className={classes.icon} />
      {megaDownPayRequired ? (
        <Grid container>
          <Grid item className={classes.header}>
            This policy's second payment is set to bill with the down payment.
          </Grid>
          <Grid item className={classes.text}>
            To avoid two separate bills on the same day we are adding the second payment to the down payment. This
            results in a larger initial payment but fewer total payments. It will not change the total term price. You
            may avoid this by changing the billing day to be 15 or more days from the date of purchase.
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Grid item className={classes.header}>
            This policy's second payment is set to bill less than 15 days after the down payment.
          </Grid>
          <Grid item className={classNames(classes.text, classes.extraBottomPadding)}>
            To avoid two bills within 10 days, we suggest combining the second payment amount with the down payment.
            This results in a larger initial payment but 5 total payments instead of 6. It will not change the total
            term price. You may also avoid this by changing the billing day to be 15 or more days from the date of
            purchase.
          </Grid>
          <Grid container>
            <FormField
              type="checkbox"
              name={formikValue}
              id={formikValue}
              label="Add second payment to down payment billing"
              fast={false}
            />
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

MegaDownPayCard.propTypes = {
  megaDownPayRequired: PropTypes.bool.isRequired,
  formikValue: PropTypes.string.isRequired
};

export default MegaDownPayCard;
